import * as $ from "jquery";
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as moment from "moment";
import { getSetScroll } from "./set_scroll"
import { Calculator, MOMENT_DATE_FORMAT } from "./components/calculator/calculator";
import { VideoPlayer } from "./components/video_player";
import { parse } from "query-string";

function init() {
    // the height (in pixels) of the fixed header nav
    const HEADER_HEIGHT = $(".header__container").height();
    const MOBILE_HEADER_HEIGHT = $(".header__container").height();
    // this is the maximum viewport width (in pixels) for a device to be considred mobile
    const MOBILE_WIDTH = 767;

    const params = parse(location.search);
    // set scrolling functionaly for all our fragment links
    const setScroll = getSetScroll(HEADER_HEIGHT, MOBILE_HEADER_HEIGHT, MOBILE_WIDTH);
    setScroll($("a.welcome-link"));
    setScroll($("a.getting-started-link"));
    setScroll($("a.shoot-overview-link"));
    setScroll($("a.profile-review-link"));
    setScroll($("a.prep-production-link"));
    setScroll($("a.resources-link"));
    setScroll($("a.go-live-link"));
    setScroll($("a.faqs-link"));

    // set the greeting image / div to take up the full viewport
    $("#onboarding").height(window.innerHeight - HEADER_HEIGHT);
    $(".copyright").text(`© ${new Date().getFullYear()} Daily Muse Inc.`);

    let startDate = moment(params.start_date);
    
    if (!params.start_date) {
        startDate.add(14, 'days');
    }
    
    const reactRoot = document.getElementById("react-root");

    ReactDOM.render(
        <Calculator
            startDate={startDate}
            companyName={params.company_name}
        />,
        reactRoot
    );

    $(".video-modal-button").each((_, node) => {
        const videoID = $(node).data("video-id");
        ReactDOM.render(<VideoPlayer videoID={videoID} />, node);
    });
}

document.addEventListener("DOMContentLoaded", init);



// WEBPACK FOOTER //
// ./src/ts/index.tsx